import React, { FC } from 'react';
import { View } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import { isWeb } from '@helpers';

import { fullHeight, fullWidth, scale as initialScale } from '@components/frame';
import BigSlider from '@v2/components/imageHandling/components/BigSlider';
import ColorWrapper from '@styles/colors';
import { PictureProps } from '@v2/components/imageHandling/components/Picture';
import { font as initialFont } from '@styles/fonts';
import SmallSlider from '@v2/components/imageHandling/components/SmallSlider';
import { ACTIVE_THUMBNAIL_HEIGHT } from '@v2/components/imageHandling/constants';

interface SlidersWrapperProps extends PictureProps {}

const SlidersWrapper: FC<SlidersWrapperProps> = (props) => {
  const {
    images,
    selectedIndex,
    setSelectedIndex,
    C,
    onImagePress,
    // showActions,
    isSingleImage,
    width = fullWidth,
    height = fullHeight,
    smallSliderBg = 'Background/Light/menuApp',
    bg,
    singleImageInBigSlider,
    withoutAttachItems,
    withNotchTop,
    zoomableOverlay,
    shouldUseColorWrapperForBigSliderBg = true,
    shouldUseColorWrapperForSmallSliderBg = true,
    scale = initialScale,
    font = initialFont,
  } = props;

  // Only use scroll progress synchronization for tablet/mobile, not web
  const scrollProgress = !isWeb ? useSharedValue(selectedIndex) : undefined;

  const bigSliderHeight = isSingleImage ? height : height - scale(ACTIVE_THUMBNAIL_HEIGHT);
  const bigSliderBg = bg ? (shouldUseColorWrapperForBigSliderBg ? C(bg) : bg) : 'transparent';

  return (
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', width, height }}>
      <BigSlider
        {...{
          onImagePress,
          images,
          selectedIndex,
          setSelectedIndex,
          width,
          height: bigSliderHeight,
          scrollProgress,
          bg: bigSliderBg,
          singleImageInBigSlider,
          withoutAttachItems,
          withNotchTop,
          zoomableOverlay,
          scale,
          font,
        }}
      />
      <SmallSlider
        {...{
          images,
          selectedIndex,
          width,
          scale,
          font,
          scrollProgress,
          bg: shouldUseColorWrapperForSmallSliderBg ? C(smallSliderBg) : smallSliderBg,
          onSelectImage: setSelectedIndex,
        }}
      />
    </View>
  );
};

export default ColorWrapper(SlidersWrapper);
